import React from 'react'
import { Toaster } from '@CommonComponents/toast';
import { useFetchData } from './hooks'
import { getDatetimeFormatter } from './utils';
import { StudentViewer } from './students/index.js';
import { ActivityViewer } from './activities/index.js';
import { PendingChangesViewer } from './pendingChanges/index.js';
import { StateProvider, useStateValue } from '@State'
import { reducer, initialState, actions } from './reducer'
import { AVAILABLE_STRATEGIES } from './applyStrategies.js'

export function App({ coursenum, restrictInstructor }) {
  return (
    <StateProvider reducer={reducer} initialState={initialState}>
      <AppContent coursenum={coursenum} restrictInstructor={restrictInstructor} />
    </StateProvider>
  )
}

function AppContent({ coursenum, restrictInstructor }) {
  const timeZoneFormatter = getDatetimeFormatter()
  const { students, activities, state, refresh } = useFetchData(coursenum)

  return <div className="container" style={{ width: '100%' }}>
    <Toaster />
    <StrategySelector restrictInstructor={restrictInstructor} />
    <ActivityViewer allActivities={activities} state={state} timeZoneFormatter={timeZoneFormatter} />
    <StudentViewer allStudents={students} state={state} />
    <PendingChangesViewer
      allActivities={activities}
      allStudents={students}
      coursenum={coursenum}
      timeZoneFormatter={timeZoneFormatter}
      refresh={refresh}
    />
  </div >
}

function StrategySelector({ restrictInstructor }) {
  const [, dispatch] = useStateValue()
  return <div className="card-myed">
    <h3>Options</h3>
    <div className='card-myed'>
      <div className="form-group">
        <label>Apply Strategy</label>
        <select className="form-control" onChange={e => dispatch({ type: actions.SET_STRATEGY, value: e.target.value })}>
          {AVAILABLE_STRATEGIES.map((value, idx) => {
            if (restrictInstructor && value.instructorsRestricted) return null
            return <option value={idx} key={idx}>{value.text}</option>
          })}
        </select>
      </div>
      <div className="alert alert-warning">
        <i className="fa-solid fa-triangle-exclamation"></i> Select a strategy before configuring other options.
      </div>
    </div>
    <div className="alert alert-info">
      <i className="fa-solid fa-clock"></i> Timezone: <strong>{Intl.DateTimeFormat().resolvedOptions().timeZone}</strong>
      <br />
      All dates and times are displayed using the above.
    </div>
  </div >
}
